export const POSITIVE_COLOR = "shadesOfDark.dark";
export const NEGATIVE_COLOR = "primaryColors.collabDefault.dark";
